module.exports = __webpack_public_path__ + "media/creativeMedia/panel-1.2-441cea33.jpg";